import { render, staticRenderFns } from "./MetricsCard.vue?vue&type=template&id=519bb74b&"
import script from "./MetricsCard.vue?vue&type=script&lang=js&"
export * from "./MetricsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports